module.exports = __webpack_public_path__ + "img/logo.784f3e3a.svg";